/**
 * Sayfa anahtari (pk) cozumlemesi.
 *
 * Ayni icerigin farkli URL'lerle tekrar tekrar analiz edilmemesi icin sayfa
 * kimligi normalize edilmis URL uzerinden uretilir:
 *  - hash atilir (hash-routing `#/...` haric)
 *  - tum query parametreleri atilir; yalnizca keepQueryParams korunur
 *  - sondaki "/" kirpilir
 *
 * Canonical link BILEREK kullanilmaz: e-ticaret sitelerinde varyant sayfalari
 * (iphone-256gb-siyah.html, iphone-1tb-gumus.html) canonical ile ana urune
 * isaret eder. Canonical'dan pk uretmek tum varyantlari tek sayfa kaydina
 * yiginliyordu: varyantlarin sayfa detayi / AI analizi / katalog kaydi hic
 * olusmuyor, ana sayfanin icerigi her varyantla ezilip "kararsiz" oluyordu.
 * Canonical yalnizca meta bilgisi olarak toplanir (bkz. meta.js).
 *
 * pk sunucuda WebPage.pk ve WebEvent.page.key olarak kullanilir.
 */

/** cyrb53: hizli, kriptografik olmayan hash. Degisiklik tespiti icin yeterli. */
export function cyrb53(input, seed) {
    const text = String(input || "");
    let h1 = 0xdeadbeef ^ (seed || 0);
    let h2 = 0x41c6ce57 ^ (seed || 0);

    for (let i = 0; i < text.length; i++) {
        const ch = text.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }

    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);

    const value = 4294967296 * (2097151 & h2) + (h1 >>> 0);
    const hex = value.toString(16);
    return hex.length >= 14 ? hex.slice(0, 14) : new Array(14 - hex.length + 1).join("0") + hex;
}

function trimTrailingSlash(path) {
    if (!path || path === "/") return path || "/";
    return path.replace(/\/+$/, "") || "/";
}

/**
 * Korunacak query parametrelerini siralı ve normalize sekilde birlestirir.
 * ?id=2&x=1 ile ?x=1&id=2 ayni sayfayi gosterir; sira farki pk'yi degistirmemeli.
 */
function buildQuery(url, keepParams) {
    if (!keepParams || keepParams.length === 0) return "";
    const kept = [];
    try {
        const params = url.searchParams;
        for (let i = 0; i < keepParams.length; i++) {
            const value = params.get(keepParams[i]);
            if (value !== null && value !== "") kept.push(keepParams[i] + "=" + String(value).slice(0, 120));
        }
    } catch (e) {
        return "";
    }
    kept.sort();
    return kept.length > 0 ? "?" + kept.join("&") : "";
}

/**
 * @param {Array<String>} [keepQueryParams] pages.keepQueryParams ayari
 * @returns {Object} { pk, url, host, path, query }
 */
export function resolvePageKey(keepQueryParams) {
    let url;
    try {
        url = new URL(window.location.href);
    } catch (e) {
        return null;
    }

    const host = String(url.hostname || "").toLowerCase();
    const path = trimTrailingSlash(url.pathname || "/");
    const query = buildQuery(url, keepQueryParams);

    // Hash-routing kullanan sitelerde (#/urun/5) hash yolun parcasidir
    let hashPath = "";
    const hash = url.hash || "";
    if (hash.indexOf("#/") === 0) hashPath = trimTrailingSlash(hash.slice(1));

    const normalizedPath = hashPath ? path + hashPath : path;

    // Saklanan adres pk ile ayni normalizasyondan gecer: ziyaretcinin
    // location'indaki utm / token / e-posta gibi query parametreleri kayda girmez
    const cleanUrl = url.protocol + "//" + url.host + path + query + (hashPath ? "#" + hashPath : "");

    return {
        pk: cyrb53(host + normalizedPath + query),
        url: cleanUrl.slice(0, 1000),
        host: host,
        path: normalizedPath.slice(0, 500),
        query: query.slice(0, 300),
    };
}

export default resolvePageKey;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/pages/pageKey.js
// module id = null
// module chunks = 